import BaseControls from './BaseControls';

export default BaseControls;
